import React from "react";
import { Link } from "react-router-dom";
import StaticPage from "./StaticPage";
import { CheckCircle2, ArrowRight, Handshake } from "lucide-react";

const points = [
  "Get discovered by verified schools looking for reliable supply partners.",
  "Receive Requests for Quotation and submit quotations in a structured format.",
  "Track purchase orders, deliveries and payments — end to end.",
  "Build a public performance rating that principals trust.",
  "Focus on serving schools well — SchoolLane handles discovery, paperwork and payments.",
];

export default function Vendors() {
  return (
    <StaticPage
      title="Partner with SchoolLane"
      subtitle="Become a supply partner for schools across India — without cold-calling principals."
    >
      <div className="not-prose grid md:grid-cols-2 gap-4 mt-4">
        {points.map((line) => (
          <div key={line} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4">
            <CheckCircle2 size={20} className="text-brand-green mt-0.5" />
            <span className="text-sm text-slate-700 leading-relaxed">{line}</span>
          </div>
        ))}
      </div>

      <div className="not-prose mt-14 rounded-2xl bg-gradient-to-br from-brand-navy to-brand-blueDark text-white p-8 sm:p-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-blue-100">
            Existing partner?
          </div>
          <div className="mt-1 text-2xl font-heading font-semibold">
            Sign in to your partner workspace to view RFQs, quotations and purchase orders.
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link to="/login" data-testid="partners-cta-login"
                className="px-5 py-3 rounded-md bg-white text-brand-navy font-semibold hover:bg-blue-50 transition-colors duration-200 inline-flex items-center gap-2">
            <Handshake size={16} /> Partner Login
          </Link>
          <Link to="/register" data-testid="partners-cta-register"
                className="px-5 py-3 rounded-md border border-white/30 text-white font-semibold hover:bg-white/10 transition-colors duration-200 inline-flex items-center gap-2">
            Apply to Partner <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </StaticPage>
  );
}
